// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2T7X_","row":"ProcedureTreatmentSummary_row__1BQWI"};